import Vue from 'vue';
import skyCrop from './sky-crop';

Vue.component('sky-crop', skyCrop);

export default skyCrop;



// WEBPACK FOOTER //
// ./scripts/sky-crop/index.js